import { buildActivityPayload, mapActivityRow } from '../mappers/activities'
import { ActivitiesRepository } from '../repositories/activities.repository'
import type { ActivityRow } from '../types/database.types'
import { unwrap } from './result'

export const ActivityService = {
  async listForProspect(prospectId: string): Promise<ActivityRow[]> {
    return unwrap(await ActivitiesRepository.listByProspectId(prospectId)).map(
      mapActivityRow,
    )
  },

  async create(input: Record<string, unknown>): Promise<ActivityRow> {
    const payload = buildActivityPayload(input)
    return mapActivityRow(unwrap(await ActivitiesRepository.create(payload)))
  },
}
